import React from 'react';
import PropTypes from 'prop-types';
import css from './Schedule.css';
import DateOption from './DateOption';
import Calendar from './Calendar';
import moment from 'moment';
import {throttle} from 'lodash';
import {getTenantConfig} from 'utils/tenant';
import {getDateFormat} from "../../../utils/time";
import {withNotification} from 'common/withNotification';
import DateValidation from './DateValidation';

class Filter extends React.Component {

  constructor(props) {
    super(props);
    const width = window.innerWidth;
    this.state = {
      startDate: this.props.startDate,
      startDateString: moment(props.startDate).format(getDateFormat('dateDisplayFormat')),
      endDate: this.props.endDate,
      endDateString: moment(props.endDate).format(getDateFormat('dateDisplayFormat')),
      isStartDateSelected: !this.isSmallScreen(width),
      isEndDateSelected: false,
      width,
      maxSchedulingRange: getTenantConfig('STUDENT_SCHEDULING_MAX_DATE_RANGE') || 180,
      defaultDateRange: getTenantConfig('STUDENT_SCHEDULING_DEFAULT_DATE_RANGE') || 2
    };

    this.onCalendarDateChange.bind(this);

    // Reference: https://stackoverflow.com/questions/38564080/remove-event-listener-on-unmount-react
    this.onResize = throttle(this.onResize.bind(this), 1000);
  }

  get calendar() {
    if (!this.state.isStartDateSelected && !this.state.isEndDateSelected) return null;
    return (
      <Calendar
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        isOutsideRange={DateValidation.isOutsideRange.bind(this)}
        onCalendarDateChange={this.onCalendarDateChange.bind(this)}

      />
    );
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, false);
  }

  onResize() {
    const width = window.innerWidth;
    const {isStartDateSelected, isEndDateSelected} = this.state;
    this.setState({
      width,
      isStartDateSelected: isStartDateSelected || (!isEndDateSelected && !this.isSmallScreen(width))
    });
  }

  isSmallScreen(width) {
    return width < 768;
  }

  onCalendarDateChange(dates) {

    const startDate = dates.startDate;
    this.props.notification.dismiss();
    const endDate = this.parseEndDate(startDate, dates.endDate);

    if (DateValidation.isOutsideMaxSchedulingRange(startDate, endDate, this.state.maxSchedulingRange)) {
      this.props.notification.error("The Selected Date Range is too Large");
      return;
    }
    this.calendarDateChangeSetState(startDate, endDate);
    this.adjustCalendarForScreenSizeAndDateChanges(startDate, endDate)

  }

  adjustCalendarForScreenSizeAndDateChanges(startDate, endDate) {
    this.props.onStartDateChanged(startDate);
    if (this.state.isEndDateSelected) {
      this.props.onEndDateChanged(endDate);
      if (this.isSmallScreen(this.state.width)) this.closeCalendar();
    } else {
      this.selectEndDate();
    }

  }
  parseEndDate(startDate, endDate) {
    return (endDate === null || typeof endDate === 'undefined') ?  startDate.clone().add(this.state.defaultDateRange, 'days') : endDate;
  }

  calendarDateChangeSetState(startDate, endDate) {

    this.setState({
      startDate: startDate,
      startDateString: (startDate === null || typeof startDate === 'undefined') ? '' : startDate.format(getDateFormat('dateDisplayFormat')),
      endDate: endDate,
      endDateString: (endDate === null || typeof endDate === 'undefined') ? '' : endDate.format(getDateFormat('dateDisplayFormat'))
    })
  }

  closeCalendar() {
    this.setState({isStartDateSelected: false, isEndDateSelected: false});
  }

  selectStartDate() {
    if (!this.isSmallScreen(this.state.width) && this.state.isStartDateSelected) return;
    this.setState({isStartDateSelected: true, isEndDateSelected: false});
  }

  selectEndDate() {
    if (!this.isSmallScreen(this.state.width) && this.state.isEndDateSelected) return;
    this.setState({isEndDateSelected: true, isStartDateSelected: false});
  }

  onStartDateStringChange(e) {
    this.setState({startDateString: e.target.value});
  }

  onEndDateStringChange(e) {
    this.setState({endDateString: e.target.value});
  }

  getDateValidationMessages(startDate, endDate) {

    const errorMsg = "" + DateValidation.validDate(startDate, "Start")
      + DateValidation.validDate(endDate, "End")
      + DateValidation.withinRange(startDate, "Start")
      + DateValidation.withinRange(endDate, "End")
      + DateValidation.startBeforeEnd(startDate, endDate)
      + DateValidation.rangeTooLarge(startDate, endDate, this.state.maxSchedulingRange)
    return errorMsg;
  }

  onDateStringsBlur() {

    const startDate = moment(this.state.startDateString, getDateFormat('dateDisplayFormat'));
    const endDate = moment(this.state.endDateString, getDateFormat('dateDisplayFormat'));

    this.props.notification.dismiss();

    const errorMsg = this.getDateValidationMessages(startDate, endDate);

    if (errorMsg !== '') {
      this.props.notification.error(errorMsg);
      return;
    }

    this.props.onStartDateChanged(startDate);
    this.props.onEndDateChanged(endDate);

    this.setState({startDate, endDate})
    if (this.state.isEndDateSelected && this.state.endDateString !== null  && this.isSmallScreen(this.state.width)) {
       this.closeCalendar();
    }
    this.props.notification.dismiss();

  }

  render() {
    return (
      <div className={css['filter-container']}>
        {this.props.notification.render()}
        <DateOption
          startDate={this.state.startDateString}
          endDate={this.state.endDateString}
          onStartDateClick={this.selectStartDate.bind(this)}
          onEndDateClick={this.selectEndDate.bind(this)}
          onDatesBlur={this.onDateStringsBlur.bind(this)}
          onEndDateChange={this.onEndDateStringChange.bind(this)}
          onStartDateChange={this.onStartDateStringChange.bind(this)}
        />
        {this.calendar}
      </div>
    );
  }
}

Filter.propTypes = {
  onSlotTypeDropdownChanged: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
  onStartDateChanged: PropTypes.func,
  onEndDateChanged: PropTypes.func,
  notification: PropTypes.object
};

export default withNotification(Filter)
